import {createGlobalStyle} from 'styled-components';

const GlobalStyles = createGlobalStyle`
  html {
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
    margin: 0;
    padding: 0;
  }

  body, #root, main {
    background: ${({ theme }) => theme.background.primary};
    font-family: ${({ theme }) => theme.text.font}, sans-serif;
    min-height: 100vh;
    width: 100vw;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #root > div {
    color: ${({ theme }) => theme.text.primary};
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.text.primary};
  } 

  .a-enter-vr {
    display: none;
  }

  select,
  textarea,
  input {
    font-size: 16px !important;
  }

  .shopify-buy__layout-vertical.shopify-buy__product {
    visibility: hidden;
  }

  .menu-hr {
    border: 0.5px solid white;
    width: 15vw;
  }

  .subroom {
    margin-left: 50px;
  }

  .overview-map-button img {
    width: 61px;
  }

  .tooltiptext {
    width: 200px;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px 5px;
    border-radius: 6px;
    z-index: 1;
  }

  #ui-controls {
    height: fit-content;
  }

  #ui-controls {
    z-index: 1054;
  }

  div.react-tutorial-container.active {
    display: flex;
    background: rgba(0, 0, 0, 0.15);
  }

  div#tutorial-instructions {
      display:flex;
      align-self: flex-start;
      justify-self: flex-end;
  }

  @media screen and (max-width: 901px) {
    .tooltiptext {
      position: relative;
      width:fit-content;
      margin:2px;
      font-size:10px;
    }

    a.float-xs-right.btn.btn-secondary {
      margin:20px;
    }

    .overview-map-button img {
      width: 20px
    }

    .mobile-hidden {
      display:none;
    }
  }

  @media screen and (max-width: 600px) {

    div.status>h4 {
      display:none
    }

    .react-tutorial-container .status div.actions a.btn.btn-secondary {
      display:none;
    }

    .react-tutorial-container ul.steps {
      display:none;
    }
  }
`;

export default GlobalStyles;
